import { render, staticRenderFns } from "./SupportPromptTemplateTest.vue?vue&type=template&id=0a05c58f&scoped=true"
import script from "./SupportPromptTemplateTest.vue?vue&type=script&lang=js"
export * from "./SupportPromptTemplateTest.vue?vue&type=script&lang=js"
import style0 from "./SupportPromptTemplateTest.vue?vue&type=style&index=0&id=0a05c58f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05c58f",
  null
  
)

export default component.exports